export type direction = 'left' | 'right';
export const validEdges = ['left', 'right', 'bottom'] as const;
export type validEdge = (typeof validEdges)[number];